import React from 'react';
import Enumerable from 'linq';
import styles from './styles/Goods.sass';

class Goods extends React.Component {
  componentDidMount() {
    const { getGoods } = this.props;

    getGoods();
  }

  render() {
    const { goods } = this.props;

    return (
      <div className={styles.goods}>
        <header>
          <img
            src={require('images/goods-header.jpg')}
            alt='goods-header'
          />
        </header>
        <ul>
          {
            Enumerable
              .from(goods)
              .select((element, index) => (
                <li key={index}>
                  <img
                    src={`/images/${element.imageName}`}
                    alt={index}
                  />
                  <div className={styles.name}>
                    {
                      Array.isArray(element.name) ?
                        (
                          Enumerable
                            .from(element.name)
                            .select((element, index) => (
                              <p key={index}>
                                {element}
                              </p>
                            ))
                            .toArray()
                        ) :
                        element.name
                    }
                  </div>
                  <div className={styles.price}>
                    {element.price}
                  </div>
                  <div className={styles.text}>
                    {element.text}
                  </div>
                </li>
              ))
              .toArray()
          }
        </ul>
      </div>
    );
  }
}

export default Goods



// WEBPACK FOOTER //
// src/components/goods/index.js